import React, { useMemo, useState } from "react";
import {
  useGetAdminEstimateTemplatesQuery,
  useUploadEstimateTemplateMutation,
} from "../toolkitServices/invoiceTemplateApi";

const modalOverlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.35)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modalStyle = {
  width: "100%",
  maxWidth: "520px",
  background: "#fff",
  borderRadius: "12px",
  padding: "20px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const headerRowStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "16px",
};

const primaryBtnStyle = {
  background: "#0d6efd",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  padding: "10px 16px",
  cursor: "pointer",
  fontWeight: 600,
};

const secondaryBtnStyle = {
  background: "#f1f3f5",
  color: "#222",
  border: "1px solid #d9dee3",
  borderRadius: "8px",
  padding: "10px 16px",
  cursor: "pointer",
  fontWeight: 600,
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #d9dee3",
  borderRadius: "8px",
  marginTop: "8px",
};

const tableWrapStyle = {
  background: "#fff",
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  overflow: "hidden",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const thtdStyle = {
  padding: "12px 14px",
  borderBottom: "1px solid #eef1f4",
  textAlign: "left",
  fontSize: "14px",
};
// same styles invoice wali file se copy rakho

function CreateEstimateTemplateModal({ open, onClose, onUploaded }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadEstimateTemplate, { isLoading }] =
    useUploadEstimateTemplateMutation();

  if (!open) return null;

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select an estimate template file");
      return;
    }

    try {
      await uploadEstimateTemplate(selectedFile).unwrap();
      alert("Estimate template uploaded successfully");
      setSelectedFile(null);
      onClose();
      onUploaded?.();
    } catch (error) {
      alert(error?.data?.message || error?.message || "Upload failed");
    }
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalStyle}>
        <div style={headerRowStyle}>
          <h3 style={{ margin: 0 }}>Create Estimate Template</h3>
          <button
            type="button"
            onClick={onClose}
            style={{ ...secondaryBtnStyle, padding: "6px 12px" }}
          >
            X
          </button>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: 600 }}>Upload Estimate Template File</label>
          <input
            type="file"
            accept=".ejs,.html"
            style={inputStyle}
            onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
          />
          {selectedFile && (
            <div style={{ marginTop: "8px", fontSize: "13px", color: "#555" }}>
              Selected: {selectedFile.name}
            </div>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <button type="button" onClick={onClose} style={secondaryBtnStyle}>
            Cancel
          </button>
          <button
            type="button"
            onClick={handleUpload}
            style={primaryBtnStyle}
            disabled={isLoading}
          >
            {isLoading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function EstimateTemplateList() {
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const {
    data: templateResponse,
    isLoading,
    isFetching,
    refetch,
  } = useGetAdminEstimateTemplatesQuery();

  const templateRows = useMemo(() => {
    if (Array.isArray(templateResponse)) return templateResponse;
    if (Array.isArray(templateResponse?.data)) return templateResponse.data;
    if (Array.isArray(templateResponse?.rows)) return templateResponse.rows;
    return [];
  }, [templateResponse]);

  return (
    <div style={{ padding: "20px" }}>
      <div style={headerRowStyle}>
        <div>
          <h2 style={{ margin: 0 }}>Estimate Templates</h2>
          <p style={{ margin: "6px 0 0", color: "#6b7280" }}>
            Manage predefined and uploaded estimate templates
          </p>
        </div>

        <button
          type="button"
          style={primaryBtnStyle}
          onClick={() => setOpenCreateModal(true)}
        >
          Create
        </button>
      </div>

      <div style={tableWrapStyle}>
        <table style={tableStyle}>
          <thead>
            <tr style={{ background: "#f8fafc" }}>
              <th style={thtdStyle}>#</th>
              <th style={thtdStyle}>Template Name</th>
              <th style={thtdStyle}>Template Key</th>
              <th style={thtdStyle}>File Name</th>
            </tr>
          </thead>

          <tbody>
            {isLoading || isFetching ? (
              <tr>
                <td style={thtdStyle} colSpan={4}>Loading...</td>
              </tr>
            ) : templateRows.length === 0 ? (
              <tr>
                <td style={thtdStyle} colSpan={4}>No estimate templates found</td>
              </tr>
            ) : (
              templateRows.map((item, index) => (
                <tr key={item?._id || item?.templateKey || index}>
                  <td style={thtdStyle}>{index + 1}</td>
                  <td style={thtdStyle}>{item?.templateName || item?.name || "-"}</td>
                  <td style={thtdStyle}>{item?.templateKey || item?.key || "-"}</td>
                  <td style={thtdStyle}>{item?.fileName || item?.originalName || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <CreateEstimateTemplateModal
        open={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        onUploaded={refetch}
      />
    </div>
  );
}